/* © 2026 FRONT OFFICE合同会社 (Front Office G.K.), Tokyo. All rights reserved. Not licensed for reuse. */
/* ==========================================================================
   The Rail — home. design_handoff_front_office_2/08-the-rail.md

   Ported from the-rail-prototype.html, behaviour unchanged:
   - hover (desktop) or the centred garment (phone) names it; click goes to the page
   - the caption never moves on the phone; only the red line does, drawn at rest
   - transforms only while the rail is moving; nothing on the main thread
   - the window past the end of the rail follows Tokyo's clock and weather

   Reads one JSON block written by sections/the-rail.liquid. Nothing here
   knows a garment by name: order, images and states all come from the blocks
   Ken arranges in the theme editor.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-rail]');
  if (!root) return;
  var CFG = JSON.parse(root.querySelector('[data-rail-config]').textContent);
  var RANGE = CFG.garments;
  if (!RANGE.length) return;

  /* Geometry of the drawings shipped as theme assets: drawing units, where a
     unit is about 0.3 cm hook-tip to hem. The generator wrote these when the
     drawings were made; picked images fall back to length_cm × 3.3. */
  var KNOWN = CFG.known || {};
  var UNIT_PER_CM = 3.3;
  var NOM = { longcoat: [200, 352], jacket: [240, 230], shirt: [230, 240], knit: [230, 220], tee: [230, 224], tank: [150, 190], dress: [190, 300], trouser: [170, 330], sock: [110, 90], smalls: [110, 90] /* sock = underwear width (Ken, 4 Oct: the sock hanger was comically small) */ };
  var HANGER = CFG.hangers; /* {coat:{src,w,h,pad}, bar:{...}} */

  function el(n, a) { var e = document.createElementNS('http://www.w3.org/2000/svg', n); for (var k in a) e.setAttribute(k, a[k]); return e; }

  var scroller = root.querySelector('[data-rail-scroll]'),
      svg = root.querySelector('[data-rail-svg]'),
      rack = root.querySelector('[data-rail-rack]'),
      cap = root.querySelector('[data-rail-cap]'),
      padL = root.querySelector('[data-rail-pad]'),
      bay = root.querySelector('[data-rail-bay]'),
      bayfloor = root.querySelector('[data-rail-bayfloor]'),
      win = root.querySelector('[data-rail-window]'),
      paneEl = root.querySelector('[data-rail-pane]'),
      capwrapEl = root.querySelector('[data-rail-capwrap]'),
      leadV = root.querySelector('[data-rail-lead]'),
      leadH = root.querySelector('[data-rail-leadh]'),
      moreEl = root.querySelector('[data-rail-more]');
  var hasWindow = !!(bay && win && paneEl && CFG.street);

  var isTouch = window.matchMedia('(hover:none)').matches || window.innerWidth < 768;
  /* The rail's form (Ken, 4 Oct 2026): 'stelae' — after Niander Wallace —
     replaces the bent tube. Solid slabs stand taller than the bar: tall at
     the two ends, lower at each change of category. HEAD is the room above
     the bar that the end slabs rise into. */
  var STELAE = CFG.railForm === 'stelae', HEAD = STELAE ? 100 : 0;
  var RAIL_Y = 20 + HEAD, X0 = STELAE ? 60 : 46, items = [], x = X0, BOUNDS = [];

  /* ---------- geometry per garment ---------- */
  var BAGGED_KNOWN = CFG.baggedKnown || {};
  function geom(d) {
    var k = KNOWN[d.code];
    /* a shipped bagged drawing carries its own geometry (rail-bagged-known) */
    if (d.bagged && d.drawing && !d.drawing.picked && BAGGED_KNOWN[d.code]) { var bk = BAGGED_KNOWN[d.code]; return { w: bk.w, h: bk.h, hook: bk.hook, pad: bk.pad }; }
    if (d.drawing && d.drawing.picked && d.drawing.w && d.drawing.h) {
      var h = Math.round((d.length_cm || 100) * UNIT_PER_CM);
      var bar = isBar(d);
      return { w: Math.round(h * d.drawing.w / d.drawing.h), h: h, hook: bar ? 30 : 35, pad: bar ? 8 : 6 };
    }
    if (k && d.drawing) return { w: k.w, h: k.h, hook: k.hook, pad: k.pad };
    return null;
  }
  function isBar(d) { return d.kind === 'trouser' || d.kind === 'sock' || d.kind === 'smalls'; }

  /* ---------- build the rail ---------- */
  RANGE.forEach(function (item, i) {
    var G = geom(item);
    var o = G ? { w: G.w, h: G.h } : { w: (NOM[item.kind] || NOM.shirt)[0], h: 0 };
    var gpad = G ? G.pad : 0;
    var bar = isBar(item);
    var HG = bar ? HANGER.bar : HANGER.coat;
    var hw = HG ? Math.round(o.w * (bar ? 0.74 : 0.66)) : 0, hh = HG ? Math.round(hw * HG.h / HG.w) : 0;
    var seat = bar ? 0.87 : 0.80;
    /* Hooks over the bar (Ken, 4 Oct 2026): the hook goes over the top of the
       bar, its tip drops BEHIND it and its stem comes down IN FRONT. DROP
       lowers every hanger so the tip sits inside the bar's depth; the stem is
       re-drawn over the bar further down (the "front strips"). Empty hangers
       and covered garments hang identically: hook tip 9 units above the bar. */
    var DROP = STELAE ? 3 : 0;
    var hang = G ? RAIL_Y - Math.round((G.hook - G.pad) * 0.30) - G.pad + DROP : (HG ? RAIL_Y - 12 + DROP - Math.round(HG.pad * hh / HG.h) + Math.round(hh * seat) : RAIL_Y + 30);
    if (i > 0) {
      var prev = RANGE[i - 1], pg = geom(prev);
      var newCat = prev.group !== item.group;
      var prevW = pg ? pg.w : (NOM[prev.kind] || NOM.shirt)[0];
      var lap = [0.72, 0.78, 0.69, 0.82, 0.75, 0.71][i % 6];
      var pitch = Math.max(52, Math.round(prevW * lap));
      if (newCat) { var prevRight = x + prevW; BOUNDS.push({ x: prevRight + 46 }); x = prevRight + 92; }
      else x += pitch;
    }
    /* A garment with a page is a real link — crawlers, a keyboard, a
       cmd-click all get the page — with the drawing's <g> inside it. One
       without a page is a plain list item. */
    var label = item.code + ' ' + item.name;
    var wrap = item.url ? el('a', { 'href': item.url, 'class': 'g-link', 'role': 'listitem', 'aria-label': label }) : null;
    var g = el('g', { 'class': 'g dev', 'transform': 'translate(' + x + ',' + hang + ') rotate(' + (item.lean || 0) + ' ' + (o.w / 2) + ' 0)' });
    if (!wrap) { g.setAttribute('role', 'listitem'); g.setAttribute('tabindex', '0'); g.setAttribute('aria-label', label); }
    var sw = el('g', { 'class': 'sw' }); g.appendChild(sw);
    var hx = o.w / 2;
    if (G) {
      sw.appendChild(el('image', { 'class': 'flat drawn', href: item.drawing.src, x: 0, y: 0, width: G.w, height: G.h }));
      if (item.filled) sw.appendChild(el('image', { 'class': 'flat solid', href: item.filled.src, x: 0, y: 0, width: G.w, height: G.h }));
    } else if (HG) {
      sw.appendChild(el('image', { 'class': 'hanger', href: HG.src, x: hx - hw / 2, y: -Math.round(hh * seat), width: hw, height: hh, preserveAspectRatio: 'xMidYMax meet' }));
    } else {
      g.appendChild(el('path', { 'class': 'hook', d: 'M ' + hx + ' 4 L ' + hx + ' ' + (RAIL_Y - hang + 2) + ' M ' + (hx - 13) + ' 4 L ' + hx + ' -6 L ' + (hx + 13) + ' 4' }));
    }
    /* The locked page (Ken, 22 Sep 2026 — the-rail.liquid, bagged mode).
       A garment that has its own bagged drawing (item.bagged: the garment
       drawn inside its cover, one generated image per garment) shows that in
       place of the line drawing — handled above, where geom() reads it. A
       garment with only a line drawing gets the shared cover laid over it,
       stretched to the garment, inside .sw so it sways with the garment.
       An empty hanger stays an empty hanger: no bag (Ken's call). */
    /* The cover ends exactly at the garment's hem, so the rail's height, the
       floor and the hem the red line reaches are the home page's, unchanged
       (Ken, 22 Sep: the line "was perfect" — a longer cover had moved it). */
    if (CFG.bagged && CFG.bags && G && !item.bagged) {
      var bagTop = RAIL_Y + 8 - hang, bagBot = G.h - gpad;
      var bagW = bar ? Math.round(Math.max(o.w, hw) * 1.06) : Math.round(o.w * 1.10);
      sw.appendChild(el('image', { 'class': 'bag', href: bar ? CFG.bags.trouser : CFG.bags.coat, x: Math.round(hx - bagW / 2), y: bagTop, width: bagW, height: bagBot - bagTop, preserveAspectRatio: 'none' }));
    }
    if (wrap) { wrap.appendChild(g); svg.appendChild(wrap); } else svg.appendChild(g);
    var front = null;
    if (G && item.bagged && BAGGED_KNOWN[item.code] && BAGGED_KNOWN[item.code].stem) front = { href: item.drawing.src, x: 0, y: 0, w: G.w, h: G.h, s0: BAGGED_KNOWN[item.code].stem[0], s1: BAGGED_KNOWN[item.code].stem[1] };
    else if (!G && HG && HG.stem) { var hx0 = hx - hw / 2; front = { href: HG.src, x: hx0, y: -Math.round(hh * seat), w: hw, h: hh, s0: hx0 + HG.stem[0] * hw / HG.w, s1: hx0 + HG.stem[1] * hw / HG.w }; }
    items.push({ el: g, focusEl: wrap || g, cx: x + o.w / 2, data: item, bottom: hang + o.h - gpad, x: x, y: hang, w: o.w, h: (G ? o.h - gpad : o.h), img: G ? item.drawing.src : null, tf: g.getAttribute('transform'), front: front });
  });

  var railEnd = Math.max.apply(null, items.map(function (t) { return t.x + t.w; })) + X0 + (STELAE ? 0 : 26);
  var VH = Math.max(430, Math.max.apply(null, items.map(function (t) { return t.bottom; })) + 96);
  svg.setAttribute('viewBox', '0 0 ' + railEnd + ' ' + VH);

  /* The phone's viewport height changes every time the browser's toolbar
     collapses or expands during a scroll, and the rail was re-fitting itself
     to each change — Ken, 22 Sep 2026: "the size of the rail changes when you
     scroll up and down." So the height is measured once and re-measured only
     when the WIDTH changes (a rotation), never on a toolbar collapse. */
  var fitW = window.innerWidth, fitH = window.innerHeight, padR = null;
  function fitRack() {
    if (window.innerWidth !== fitW) { fitW = window.innerWidth; fitH = window.innerHeight; }
    if (window.innerWidth < 768) {
      var h = Math.round(Math.min(fitH * 0.56, 620));
      var MW = Math.round(h * railEnd / VH);
      rack.style.minWidth = MW + 'px'; rack.style.width = MW + 'px'; rack.style.height = h + 'px';
      padL.style.flexBasis = Math.max(0, Math.round(window.innerWidth / 2 - items[0].cx / railEnd * MW)) + 'px';
      /* Ken, 4 Oct 2026: "I can only scroll to the T-shirt … I can't hit the
         other two hangers." Without a window bay after it, the rail ended
         before its last garments could reach the centre. Pad the end too. */
      if (!hasWindow) {
        if (!padR) { padR = document.createElement('div'); padR.className = 'rail__pad'; padR.setAttribute('aria-hidden', 'true'); rack.parentNode.insertBefore(padR, rack.nextSibling); }
        padR.style.flexBasis = Math.max(0, Math.round(window.innerWidth / 2 - (railEnd - items[items.length - 1].cx) / railEnd * MW)) + 'px';
      }
    } else {
      /* 5% pass, 4 Oct 2026: on a desktop the rail no longer shrinks to fit the
         width (twelve garments at ~160px read as a sticker sheet). It is sized
         by height, like the phone, and runs off the right edge; drag or swipe. */
      var hd = Math.round(Math.min(fitH * 0.56, 720));
      var MWd = Math.round(hd * railEnd / VH);
      if (MWd > window.innerWidth) {
        rack.style.height = hd + 'px'; rack.style.width = MWd + 'px'; rack.style.minWidth = MWd + 'px'; rack.style.flex = '0 0 ' + MWd + 'px';
      } else { rack.style.height = ''; rack.style.width = ''; rack.style.minWidth = ''; rack.style.flex = ''; }
      padL.style.flexBasis = '';
      if (padR) padR.style.flexBasis = '';
    }
    requestAnimationFrame(function () {
      var h = rack.getBoundingClientRect().height;
      if (hasWindow) { bay.style.height = h + 'px'; bayfloor.style.top = Math.round(h * (VH - 12) / VH) + 'px'; }
      placeDetents();
      sizeBackdrop();
    });
  }
  window.addEventListener('resize', fitRack);

  /* A space behind the rail (Ken, 4 Oct 2026): an out-of-focus room behind
     frosted glass, moving slower than the garments so the rail reads as
     standing in front of something. The blur and the frost are baked into the
     image; nothing here filters anything (filters made the phone stutter). It
     moves by transform only. */
  var backdrop = null, bdImg = null, bdRatio = 0;
  if (CFG.backdrop) {
    backdrop = document.createElement('div'); backdrop.className = 'rail__backdrop'; backdrop.setAttribute('aria-hidden', 'true');
    bdImg = new Image(); bdImg.alt = ''; bdImg.decoding = 'async';
    bdImg.onload = function () { bdRatio = bdImg.naturalWidth / bdImg.naturalHeight; sizeBackdrop(); backdrop.classList.add('ready'); };
    bdImg.src = CFG.backdrop;
    backdrop.appendChild(bdImg);
    scroller.parentNode.insertBefore(backdrop, scroller);
  }
  function sizeBackdrop() {
    if (!backdrop || !bdRatio) return;
    var h = rack.getBoundingClientRect().height, vw = scroller.clientWidth;
    var w = Math.max(Math.round(h * bdRatio), Math.round(vw * 1.5));
    backdrop.style.height = h + 'px';
    bdImg.style.width = w + 'px'; bdImg.style.height = Math.round(w / bdRatio) + 'px';
    moveBackdrop();
  }
  function moveBackdrop() {
    if (!backdrop || !bdRatio) return;
    var max = Math.max(1, scroller.scrollWidth - scroller.clientWidth);
    var travel = bdImg.offsetWidth - scroller.clientWidth;
    var t = Math.min(1, Math.max(0, scroller.scrollLeft / max));
    bdImg.style.transform = 'translate3d(' + Math.round(-t * travel) + 'px,-50%,0)';
  }
  scroller.addEventListener('scroll', function () { requestAnimationFrame(moveBackdrop); }, { passive: true });
  window.addEventListener('resize', function () { requestAnimationFrame(sizeBackdrop); });
  rack.style.setProperty('--ar', railEnd + ' / ' + VH);
  fitRack();

  /* the steel: bar, uprights on the category boundaries, feet, floor */
  var deco = el('g', {}), T = 2, FLOOR = VH - 12, BASE = FLOOR - T;
  function steel(x, y, w, h) { return el('rect', { 'class': 'steel', x: x, y: y, width: w, height: h }); }
  /* One bent tube (Ken, 4 Oct 2026, after Niemeyer): the rod, the end
     uprights and the feet are one continuous line with radiused bends, drawn
     behind the garments; a straight length of the same rod is laid on top so
     the hooks still hang over it. The uprights at the category changes are
     the same tube, splitting into two radiused feet at the floor. */
  var R = 34, R2 = 14, FOOT = 34, L = 26, Rt = railEnd - 26, Y = RAIL_Y, B = BASE + T / 2;
  function tube(d) { return el('path', { 'class': 'tube', d: d, 'stroke-width': T }); }
  if (STELAE) {
    /* Stelae, A4 'hierarchy' (Ken, 4 Oct 2026). Material, later, in 3D:
       yakisugi, charred cedar. Line art first: solid ink slabs, the bar
       runs from one end slab to the other, through the category slabs. */
    var SW = 36, EC = 24, ER = railEnd - 24, END_TOP = Y - (HEAD - 4), MID_TOP = Y - 36;
    /* With CFG.slab (brushed yakisugi, Ken 4 Oct: option 2) each slab is the
       photographed board, cropped from the top so every slab shares one
       floor line; without it, solid ink. Slabs are laid after the bar so the
       bar runs into them. */
    function slab(cx, top, P) {
      /* Charred posts, each a distinct photographed post with brushed-nickel
         eyelets where the bar enters (Ken, 4 Oct 2026). The image is composed
         so the eyelets sit on the bar; it runs past the floor and is cropped. */
      if (P) return el('image', { 'class': 'slab slab--post', href: P.src, x: cx - P.widthU / 2 - P.eL, y: top - P.mU, width: P.widthU + P.eL + P.eR, height: FLOOR - top + P.mU, preserveAspectRatio: 'xMidYMin slice' });
      if (CFG.slab) return el('image', { 'class': 'slab slab--photo', href: CFG.slab, x: cx - SW / 2, y: top, width: SW, height: FLOOR - top, preserveAspectRatio: 'xMidYMax slice' });
      return el('rect', { 'class': 'steel slab', x: cx - SW / 2, y: top, width: SW, height: FLOOR - top });
    }
    var PO = CFG.posts && CFG.posts.length === 4 ? CFG.posts : null;
    var SLABS = [slab(EC, END_TOP, PO && PO[0]), slab(ER, END_TOP, PO && PO[1])];
    BOUNDS.forEach(function (b, k) { SLABS.push(slab(b.x, MID_TOP, PO && PO[2 + (k % 2)])); });
  } else {
  deco.appendChild(tube(
    'M ' + (L + R + FOOT) + ' ' + B + ' L ' + (L + R) + ' ' + B +
    ' A ' + R + ' ' + R + ' 0 0 1 ' + L + ' ' + (B - R) +
    ' L ' + L + ' ' + (Y + R) +
    ' A ' + R + ' ' + R + ' 0 0 1 ' + (L + R) + ' ' + Y +
    ' L ' + (Rt - R) + ' ' + Y +
    ' A ' + R + ' ' + R + ' 0 0 1 ' + Rt + ' ' + (Y + R) +
    ' L ' + Rt + ' ' + (B - R) +
    ' A ' + R + ' ' + R + ' 0 0 1 ' + (Rt - R) + ' ' + B +
    ' L ' + (Rt - R - FOOT) + ' ' + B));
  BOUNDS.forEach(function (b) {
    var x = b.x;
    deco.appendChild(tube('M ' + x + ' ' + Y + ' L ' + x + ' ' + (B - R2) +
      ' A ' + R2 + ' ' + R2 + ' 0 0 1 ' + (x - R2) + ' ' + B + ' L ' + (x - R2 - 20) + ' ' + B +
      ' M ' + x + ' ' + (B - R2) + ' A ' + R2 + ' ' + R2 + ' 0 0 0 ' + (x + R2) + ' ' + B + ' L ' + (x + R2 + 20) + ' ' + B));
  });
  }
  var barLayer = el('g', { 'class': 'barlayer' });
  if (STELAE) {
    /* A bar, not a wire (Ken, 4 Oct): 9 units, about 27 mm, still inside a
       hanger hook's crook. Its top stays where the hooks rest; it grows downward. */
    var defs = el('defs', {}), grad = el('linearGradient', { id: 'railSteel', x1: 0, y1: 0, x2: 0, y2: 1 });
    [['0', '#3a3a3a'], ['0.14', '#8f8f8f'], ['0.26', '#3c3c3c'], ['0.55', '#151515'], ['0.85', '#070707'], ['1', '#000']] /* lit from above-left like the posts (Ken, 4 Oct) */.forEach(function (s) { grad.appendChild(el('stop', { offset: s[0], 'stop-color': s[1] })); });
    defs.appendChild(grad); svg.insertBefore(defs, svg.firstChild);
    barLayer.appendChild(el('rect', { 'class': 'bar', x: EC + SW / 2, y: Y - 3, width: (ER - SW / 2) - (EC + SW / 2), height: 9, fill: (CFG.slab || PO) ? 'url(#railSteel)' : 'var(--ink)' }));
    items.forEach(function (it, i) {
      var f = it.front; if (!f) return;
      var cid = 'railStem' + i, cp = el('clipPath', { id: cid, clipPathUnits: 'userSpaceOnUse' });
      cp.appendChild(el('rect', { x: f.s0, y: (Y - 3) - it.y - 1, width: f.s1 - f.s0, height: 11 }));
      defs.appendChild(cp);
      var w = el('g', { transform: it.tf, 'clip-path': 'url(#' + cid + ')', 'class': 'stemfront' });
      w.appendChild(el('image', { href: f.href, x: f.x, y: f.y, width: f.w, height: f.h, preserveAspectRatio: f === null ? 'none' : (it.img ? 'none' : 'xMidYMax meet') }));
      barLayer.appendChild(w);
    });
    SLABS.forEach(function (n) { barLayer.appendChild(n); });
  } else if (CFG.railPhoto) {
    /* The same rail, photographed (Ken, 4 Oct 2026: "photo real, not
       illustrated real"). Pieces rendered at 8 px per unit, tube 6 units
       across; geometry in rail-assets/generated/rail-photo/BRIEF.md. The
       line drawing above is cleared and the pieces are laid on the same
       centrelines. */
    while (deco.firstChild) deco.removeChild(deco.firstChild);
    var P = CFG.railPhoto, D = 3;
    function piece(src, x, y, w, h) { return el('image', { href: src, x: x, y: y, width: w, height: h, preserveAspectRatio: 'none', 'class': 'railpiece' }); }
    deco.appendChild(piece(P.v, L - D, Y + R, 2 * D, (B - R) - (Y + R)));
    deco.appendChild(piece(P.v, Rt - D, Y + R, 2 * D, (B - R) - (Y + R)));
    deco.appendChild(piece(P.tl, L - D, Y - D, 40, 40));
    deco.appendChild(piece(P.tr, Rt - 37, Y - D, 40, 40));
    deco.appendChild(piece(P.fl, L - D, B - 37, 74, 40));
    deco.appendChild(piece(P.fr, Rt - 71, B - 37, 74, 40));
    BOUNDS.forEach(function (b) {
      deco.appendChild(piece(P.v, b.x - D, Y, 2 * D, (B - 17) - Y + 1));
      deco.appendChild(piece(P.split, b.x - 37, B - 17, 74, 20));
    });
    barLayer.appendChild(piece(P.h, L + R, Y - D, (Rt - R) - (L + R), 2 * D));
  } else {
    barLayer.appendChild(steel(L + R, Y - T / 2, (Rt - R) - (L + R), T));
  }
  deco.appendChild(el('path', { 'class': 'floor', d: 'M 0 ' + FLOOR + ' L ' + railEnd + ' ' + FLOOR }));
  svg.insertBefore(deco, svg.firstChild);
  svg.appendChild(barLayer);

  /* ---------- state ---------- */
  function released(d) { return !!d.released; }
  function stateText(d) {
    if (released(d)) return { cls: '', txt: CFG.t.released + (d.price ? ' · ' + d.price : '') };
    return { cls: 'dev', txt: CFG.t.in_development + (d.price ? ' · ' + d.price : '') };
  }
  items.forEach(function (it) {
    it.el.classList.toggle('dev', !released(it.data));
    it.el.classList.toggle('nophoto', !it.data.filled); /* released but not yet photographed: the drawing stays */
  });

  /* ---------- the name and the line ---------- */
  var LEADKEY = null, SEL = -1, introOn = false;
  function showIntro() {
    introOn = true; SEL = -1; LEADKEY = null;
    var WM = CFG.intro.wordmark;
    var label = WM ? '<div class="wm" aria-label="Front Office"><span class="wm__f">' + WM.front + '</span><span class="wm__o">' + WM.office + '</span></div>' : '<div class="num caps">' + esc(CFG.intro.label || '') + '</div>';
    cap.innerHTML = label + '<div class="nm nm--fit">' + esc(CFG.intro.line) + '</div><div class="st">' + esc(CFG.intro.sub || '') + '</div>';
    fitLine();
    if (WM) fitWordmark();
    moreEl.hidden = true; cap.style.marginLeft = '';
    leadV.classList.add('still'); leadH.classList.add('still');
    leadV.style.transform = 'translate3d(0,-400px,0) scaleY(0)'; leadH.style.transform = 'translate3d(0,0,0) scaleX(0)';
    items.forEach(function (o) { o.el.classList.remove('on'); });
  }
  /* The label above the opening line is the wordmark (Ken, 4 Oct 2026):
     FRONT at the start of the line, OFFICE at its end, so it spans exactly
     the width of the longest line of "A live studio on the internet." */
  function fitWordmark() {
    var wm = cap.querySelector('.wm'), nm = cap.querySelector('.nm'); if (!wm || !nm) return;
    var r = document.createRange(); r.selectNodeContents(nm);
    var w = 0, rs = r.getClientRects(); for (var i = 0; i < rs.length; i++) w = Math.max(w, rs[i].width);
    if (w) wm.style.width = Math.round(w) + 'px';
    var st = cap.querySelector('.st'); if (st && w) st.style.maxWidth = Math.round(w) + 'px';
  }
  /* On a phone the opening line is sized so its longest line spans the
     caption's full width (Ken, 4 Oct 2026: "take up the whole screen"). */
  function longestLine(el) { var r = document.createRange(); r.selectNodeContents(el); var w = 0, rs = r.getClientRects(); for (var i = 0; i < rs.length; i++) w = Math.max(w, rs[i].width); return w; }
  function fitLine() {
    var nm = cap.querySelector('.nm--fit'); if (!nm) return;
    nm.style.fontSize = '';
    return; /* Ken, 4 Oct 2026: keep the line's own size on the phone; the block fits the line instead */
    var cw = cap.clientWidth, base = parseFloat(getComputedStyle(nm).fontSize), fs = base;
    for (var k = 0; k < 4; k++) { var lw = longestLine(nm); if (!lw) break; fs = Math.max(base, Math.min(base * 1.5, fs * cw / lw * 0.995)); nm.style.fontSize = fs.toFixed(2) + 'px'; }
  }
  window.addEventListener('resize', function () { if (introOn) { fitLine(); fitWordmark(); } });
  /* the display face can arrive after the first paint: measure again once fonts are in */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (introOn) { fitLine(); fitWordmark(); } });
  window.addEventListener('load', function () { if (introOn) { fitLine(); fitWordmark(); } });
  function leadTo(gx, hemY, key) {
    var host = capwrapEl.getBoundingClientRect();
    var capW = Math.min(cap.offsetWidth || 17 * 16, host.width - 16);
    var moreW = (moreEl.offsetWidth || 0) + 24;
    var cx = isTouch ? 0 : Math.min(Math.max(gx, 8), Math.max(host.width - capW - 8 - moreW, 8));
    if (!isTouch) cap.style.marginLeft = cx + 'px';
    var up = Math.max(0, host.top - hemY - 6), W = Math.abs(gx - cx), L = Math.min(cx, gx);
    var changed = key !== LEADKEY; LEADKEY = key;
    var vT = 'translate3d(' + gx + 'px,-400px,0) scaleY(' + (up / 400) + ')';
    var hT = 'translate3d(' + L + 'px,0,0) scaleX(' + (W / 1000) + ')';
    if (gx < cx) { leadH.style.transformOrigin = '100% 50%'; hT = 'translate3d(' + (cx - 1000) + 'px,0,0) scaleX(' + (W / 1000) + ')'; } else { leadH.style.transformOrigin = '0% 50%'; }
    if (changed) {
      leadV.classList.add('still'); leadH.classList.add('still');
      leadV.style.transform = 'translate3d(' + gx + 'px,-400px,0) scaleY(0)';
      leadH.style.transform = (gx < cx ? 'translate3d(' + (cx - 1000) + 'px,0,0)' : 'translate3d(' + L + 'px,0,0)') + ' scaleX(0)';
      void leadV.offsetWidth;
      leadV.classList.remove('still'); leadH.classList.remove('still');
      requestAnimationFrame(function () { leadH.style.transform = hT; leadV.style.transform = vT; });
    } else {
      leadV.classList.add('still'); leadH.classList.add('still');
      leadV.style.transform = vT; leadH.style.transform = hT;
      requestAnimationFrame(function () { leadV.classList.remove('still'); leadH.classList.remove('still'); });
    }
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function writeCaption(d) {
    var st = stateText(d);
    cap.innerHTML = '<div class="num caps">' + esc(d.code.replace('-', ' ')) + '</div><div class="nm">' + esc(d.name) + '</div><div class="st ' + st.cls + '">' + esc(st.txt) + '</div>';
    if (d.url) { moreEl.href = d.url; moreEl.hidden = false; moreEl.setAttribute('aria-label', CFG.t.more + ' · ' + d.name); }
    else { moreEl.hidden = true; moreEl.removeAttribute('href'); }
  }
  function paint(i) {
    introOn = false;
    var it = items[i], d = it.data;
    if (SEL !== i) {
      writeCaption(d);
      if (isTouch && SEL >= 0) tick();
      items.forEach(function (o, j) { o.el.classList.toggle('on', j === i); });
      SEL = i;
    }
    var box = svg.getBoundingClientRect(), host = capwrapEl.getBoundingClientRect();
    var gx = box.left + (it.cx / railEnd) * box.width - host.left;
    var hemY = box.top + ((it.y + (it.h || 60)) / (svg.viewBox.baseVal.height || 1)) * box.height;
    leadTo(gx, hemY, d.code);
  }
  function paintText(i) {
    writeCaption(items[i].data);
    if (SEL >= 0) tick(); SEL = i;
    items.forEach(function (o, j) { o.el.classList.toggle('on', j === i); });
  }

  function touch(i, cls) {
    /* No swing (Ken, 4 Oct 2026: "too much swing and toggle … cartoonish").
       Garments hang still; the red line is the only thing that moves. */
    return -1;
    var e = items[i].el; if (e.classList.contains('touch')) return;
    e.classList.remove('touch', 'brush', 'roll'); void e.getBoundingClientRect();
    e.classList.add(cls);
    var end = function () { e.classList.remove('touch', 'brush', 'roll'); e.removeEventListener('animationend', end); };
    e.addEventListener('animationend', end);
  }

  /* alpha maps: the pointer hits cloth, not the transparent box around it */
  var ALPHA = {}, AS = 4;
  items.forEach(function (it, i) {
    if (!it.img) return;
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () {
      var cw = Math.max(1, Math.round(it.w / AS)), ch = Math.max(1, Math.round(it.h / AS));
      var c = document.createElement('canvas'); c.width = cw; c.height = ch;
      var ctx = c.getContext('2d'); ctx.drawImage(im, 0, 0, cw, ch);
      try { ALPHA[i] = { d: ctx.getImageData(0, 0, cw, ch).data, w: cw, h: ch }; } catch (e) { /* cross-origin canvas: fall back to the box */ }
    };
    im.src = it.img;
  });
  /* The whole column is the target (Ken, 4 Oct 2026: "a moving target from
     garment to garment … it should be a complete column"). Anywhere over the
     rail, the pointer names the garment whose centre line is nearest, so each
     garment owns a vertical band from its neighbour's midpoint to the next. */
  function colAt(clientX) {
    var box = svg.getBoundingClientRect(); if (!box.width) return -1;
    var x = (clientX - box.left) / box.width * railEnd, best = -1, bd = 1e9;
    items.forEach(function (it, i) { var d = Math.abs(x - it.cx); if (d < bd) { bd = d; best = i; } });
    return (best >= 0 && bd <= Math.max(items[best].w, 120)) ? best : -1;
  }
  function hitAt(clientX, clientY) {
    var pt = svg.createSVGPoint(); pt.x = clientX; pt.y = clientY;
    var m = svg.getScreenCTM(); if (!m) return -1;
    var p = pt.matrixTransform(m.inverse());
    for (var i = items.length - 1; i >= 0; i--) {
      var it = items[i], lx = p.x - it.x, ly = p.y - it.y;
      if (lx < 0 || ly < 0 || lx > it.w || ly > (it.h || 60)) continue;
      var A = ALPHA[i];
      if (!A) { if (!it.img && ly < 60) return i; if (it.img) return i; continue; }
      var ax = Math.min(A.w - 1, Math.floor(lx / AS)), ay = Math.min(A.h - 1, Math.floor(ly / AS));
      if (A.d[(ay * A.w + ax) * 4 + 3] > 40) return i;
    }
    return -1;
  }
  function open(i, e) {
    var u = items[i].data.url; if (!u) return;
    if (e && (e.metaKey || e.ctrlKey || e.button === 1)) { window.open(u, '_blank', 'noopener'); return; }
    window.location.href = u;
  }

  var HOV = -1;
  svg.addEventListener('mousemove', function (e) {
    if (isTouch) return;
    var i = colAt(e.clientX);
    svg.style.cursor = i >= 0 && items[i].data.url ? 'pointer' : 'default';
    if (i === HOV) return;
    HOV = i;
    if (i >= 0) { paint(i); touch(i, 'touch'); if (items[i - 1]) touch(i - 1, 'brush'); if (items[i + 1]) touch(i + 1, 'brush'); }
  });
  /* The images swallow no pointer events, so the <a> never navigates by
     itself: which garment a tap opens is decided here (the centred one on a
     phone, the one under the pointer on a desktop), never by the browser. */
  svg.addEventListener('click', function (e) {
    e.preventDefault();
    var i = colAt(e.clientX);
    if (i < 0) return;
    /* Ken, 4 Oct 2026: on the phone the rail answered only to scrolling.
       A tap now brings the tapped garment to the centre (and names it);
       tapping the garment already centred opens it. */
    if (isTouch && i !== centre()) {
      var box = svg.getBoundingClientRect(), px = box.left + items[i].cx / railEnd * box.width;
      scroller.scrollBy({ left: Math.round(px - window.innerWidth / 2), behavior: 'smooth' });
      return;
    }
    open(i, e);
  });
  svg.addEventListener('auxclick', function (e) { if (e.button !== 1 || isTouch) return; e.preventDefault(); var i = colAt(e.clientX); if (i >= 0) open(i, e); });
  items.forEach(function (it, i) {
    it.focusEl.addEventListener('focus', function () { paint(i); touch(i, 'touch'); });
    /* Enter on a link is the browser's own; Space is ours so both keys open. */
    it.focusEl.addEventListener('keydown', function (e) { if (e.key === ' ' || (e.key === 'Enter' && it.focusEl === it.el)) { e.preventDefault(); open(i, e); } });
  });
  rack.addEventListener('mouseleave', function () { if (isTouch) return; HOV = -1; svg.style.cursor = 'default'; if (CFG.intro && CFG.intro.line) showIntro(); else paint(centre()); });

  /* scrolling the rail moves the clothes on it — once, as it starts */
  var lastScroll = 0;
  function swayAll() {
    var now = Date.now(), idle = now - lastScroll > 450; lastScroll = now;
    if (!idle) return;
    items.forEach(function (it, i) { setTimeout(function () { touch(i, 'roll'); }, i * 18); });
  }
  scroller.addEventListener('scroll', swayAll, { passive: true });
  window.addEventListener('scroll', swayAll, { passive: true });

  function centre() {
    var box = svg.getBoundingClientRect(), mid = window.innerWidth / 2, best = 0, bd = 1e9;
    items.forEach(function (it, i) { var px = box.left + it.cx / railEnd * box.width, dd = Math.abs(px - mid); if (dd < bd) { bd = dd; best = i; } });
    return best;
  }
  function tick() { try { if (navigator.vibrate) navigator.vibrate(6); } catch (e) { /* not on iOS */ } }
  function placeDetents() {
    var old = scroller.querySelectorAll('.rail__detent'); for (var k = 0; k < old.length; k++) old[k].remove();
    if (!isTouch) return;
    var padW = padL.getBoundingClientRect().width, rw = rack.getBoundingClientRect().width;
    items.forEach(function (it, i) { var d = document.createElement('div'); d.className = 'rail__detent' + ((i === 0 || i === items.length - 1) ? ' stop' : ''); d.style.left = Math.round(padW + it.cx / railEnd * rw) + 'px'; scroller.appendChild(d); });
    if (hasWindow) {
      var wb = win.getBoundingClientRect(), bb = bay.getBoundingClientRect();
      var d = document.createElement('div'); d.className = 'rail__detent'; d.style.left = Math.round(padW + rw + (wb.left - bb.left) + wb.width / 2) + 'px'; scroller.appendChild(d);
    }
  }

  var ticking = false, settleT = null, inBay = false;
  /* Ken, 4 Oct 2026, on his phone: "a live studio … does not appear anywhere".
     On a real phone the rail snaps to its first detent as the page loads; that
     snap is a scroll, and the scroll handed the opening line straight over to
     a garment before anyone saw it. Only a person's own touch, drag, wheel or
     key on the rail may hand it over now. */
  var railTouched = false;
  ['touchstart', 'pointerdown', 'wheel', 'keydown'].forEach(function (t) { scroller.addEventListener(t, function () { railTouched = true; }, { passive: true }); });
  scroller.addEventListener('scroll', function () {
    if (introOn && !railTouched) return;
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      if (isTouch) { capwrapEl.classList.add('moving'); clearTimeout(settleT); settleT = setTimeout(settle, 170); }
      else if (!inBay) paint(centre());
      ticking = false;
    });
  }, { passive: true });
  function settle() {
    capwrapEl.classList.remove('moving');
    if (introOn && !railTouched) return;
    if (inBay) { paintWeather(); return; }
    SEL = -1; LEADKEY = null; paint(centre());
  }
  if ('onscrollend' in window) scroller.addEventListener('scrollend', function () { clearTimeout(settleT); settle(); });
  window.addEventListener('resize', function () { if (introOn) return; paint(centre()); });

  /* The caption speaks first (Ken, 4 Oct 2026). On the locked page the
     caption opens with the studio's line instead of a garment; the first
     paint() — a hover, a swipe, a page scroll, a focus — hands it over. */
  /* Round 2 (Ken could not see it): the line is the caption's resting state.
     Desktop: it shows until the pointer is over a garment's column and comes
     back when the pointer leaves the rail. Phone: it shows until the rail is
     swiped; scrolling the page or the toolbar resizing never hands it over. */
  if (CFG.intro && CFG.intro.line) {
    showIntro();
  } else {
    paint(isTouch ? 0 : Math.min(2, items.length - 1));
  }

  /* ---------- the window: Tokyo, live ---------- */
  /* 5% pass, 4 Oct 2026: with the rail running off the edge, a mouse can drag it.
     A drag of more than 4px swallows the click that ends it, so it never opens a garment. */
  if (!isTouch) {
    var dragX = null, dragS = 0, dragged = false;
    scroller.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      dragX = e.clientX; dragS = scroller.scrollLeft; dragged = false;
    });
    window.addEventListener('pointermove', function (e) {
      if (dragX === null) return;
      var dx = e.clientX - dragX;
      if (!dragged && Math.abs(dx) > 4) { dragged = true; scroller.classList.add('dragging'); }
      if (dragged) scroller.scrollLeft = dragS - dx;
    });
    window.addEventListener('pointerup', function () {
      if (dragX === null) return;
      dragX = null; scroller.classList.remove('dragging');
      setTimeout(function () { dragged = false; }, 0);
    });
    scroller.addEventListener('click', function (e) { if (dragged) { e.stopPropagation(); e.preventDefault(); } }, true);
  }
  if (!hasWindow) return;
  var STREET = CFG.street; /* state → image url; loaded only when the bay is near */
  var WX = null, WXTXT = { 0: 'Clear', 1: 'Mostly clear', 2: 'Partly cloudy', 3: 'Overcast', 45: 'Fog', 48: 'Fog', 51: 'Light drizzle', 53: 'Drizzle', 55: 'Drizzle', 56: 'Freezing drizzle', 57: 'Freezing drizzle', 61: 'Light rain', 63: 'Rain', 65: 'Heavy rain', 66: 'Freezing rain', 67: 'Freezing rain', 71: 'Light snow', 73: 'Snow', 75: 'Heavy snow', 77: 'Snow grains', 80: 'Showers', 81: 'Showers', 82: 'Heavy showers', 85: 'Snow showers', 86: 'Snow showers', 95: 'Thunderstorm', 96: 'Thunderstorm', 99: 'Thunderstorm' };
  var armed = false, lastState = null;
  function tokyoHour() {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Tokyo', hour: 'numeric', minute: 'numeric', hour12: false, month: 'numeric' });
    var parts = {}; f.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return { h: parseInt(parts.hour, 10) + parseInt(parts.minute, 10) / 60, m: parseInt(parts.month, 10) };
  }
  function pick(t, wx) {
    var rain = wx && ((wx.code >= 51 && wx.code <= 67) || (wx.code >= 80 && wx.code <= 82) || wx.code >= 95);
    var snow = wx && ((wx.code >= 71 && wx.code <= 77) || wx.code === 85 || wx.code === 86);
    var night = wx ? !wx.isDay : (t.h < 5.5 || t.h >= 18);
    var dusk = wx ? (Math.abs(t.h - wx.sunset) < 0.75 || Math.abs(t.h - wx.sunrise) < 0.6) : ((t.h >= 17 && t.h < 18) || (t.h >= 5.5 && t.h < 6.5));
    if (snow) return 'snow';
    if (rain) return night ? 'night-rain' : 'rain';
    if (night) return 'night';
    if (dusk) return 'dusk';
    if (t.m === 4) return 'spring';
    if (t.m === 11) return 'autumn';
    return 'day';
  }
  function show(state) {
    lastState = state; if (!armed) return;
    var src = STREET[state] || STREET.day; if (!src) return;
    paneEl.style.backgroundImage = 'url(' + src + ')';
    paneEl.className = 'rail__pane ' + state;
  }
  function run() {
    var t = tokyoHour(); show(pick(t, null));
    if (!window.fetch) return;
    fetch('https://api.open-meteo.com/v1/forecast?latitude=35.644&longitude=139.699&current=weather_code,is_day,temperature_2m&daily=sunrise,sunset&timezone=Asia%2FTokyo')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var hm = function (iso) { var s = iso.split('T')[1].split(':'); return parseInt(s[0], 10) + parseInt(s[1], 10) / 60; };
        WX = { t: Math.round(j.current.temperature_2m), c: j.current.weather_code };
        show(pick(t, { code: j.current.weather_code, isDay: j.current.is_day === 1, sunrise: hm(j.daily.sunrise[0]), sunset: hm(j.daily.sunset[0]) }));
      }).catch(function () { /* the window falls back to the clock */ });
  }
  function arm() { if (armed) return; armed = true; run(); setInterval(run, 10 * 60 * 1000); }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) arm(); }); }, { root: scroller, rootMargin: '0px 100% 0px 100%' }).observe(bay);
  } else arm();

  function tokyoClock() { return new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Tokyo', hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date()); }
  function tokyoDate() { return new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Tokyo', weekday: 'long', day: 'numeric', month: 'long' }).format(new Date()); }
  function paintWeather() {
    var line = WX ? (WX.t + '°C, ' + (WXTXT[WX.c] || '').toLowerCase()) : tokyoDate();
    cap.innerHTML = '<div class="num caps">' + esc(CFG.t.shibuya) + ' · ' + tokyoClock() + ' ' + esc(CFG.t.jst) + '</div><div class="nm">' + esc(line) + '</div><div class="st">' + esc(WX ? tokyoDate() : CFG.t.live) + '</div>';
    var w = win.getBoundingClientRect(), host = capwrapEl.getBoundingClientRect();
    SEL = -1; leadTo(w.left + w.width / 2 - host.left, w.bottom, 'window');
    items.forEach(function (o) { o.el.classList.remove('on'); });
  }
  function parallax() {
    var sx = scroller.scrollLeft || 0, start = rack.getBoundingClientRect().width - window.innerWidth;
    var d = Math.max(0, sx - start);
    if (!isTouch) win.style.setProperty('--px', (d * 0.12) + 'px');
    paneEl.style.setProperty('--bx', (-d * 0.08) + 'px');
  }
  scroller.addEventListener('scroll', function () {
    requestAnimationFrame(parallax);
    var w = win.getBoundingClientRect();
    var visible = w.left < window.innerWidth * 0.72;
    if (visible && !inBay) { inBay = true; capwrapEl.classList.add('bay'); if (!isTouch) paintWeather(); }
    else if (!visible && inBay) { inBay = false; capwrapEl.classList.remove('bay'); if (!isTouch) paint(centre()); }
    else if (visible && !isTouch) paintWeather();
  }, { passive: true });
  if (!isTouch) {
    document.addEventListener('mousemove', function (e) {
      var r = (e.clientX / window.innerWidth - 0.5);
      requestAnimationFrame(function () { paneEl.style.setProperty('--bx', (-r * 8) + 'px'); });
    }, { passive: true });
  }
})();
